import { useFormatters } from '../../contexts/PreferencesContext';

/**
 * The three formatter wrappers the PO Details panels share.
 *
 * Extracted verbatim from PODetailModal when its tab panels moved into their
 * own components (CR-7258 follow-up, to bring the file back under the 500-line
 * limit). The wrappers exist because the API sends money as strings and dates
 * as possibly-empty strings, which the context formatters do not handle.
 *
 * @returns The wrapped formatters plus the raw display preferences.
 */
export function usePODetailFormatters() {
  const {
    formatCurrency: contextFormatCurrency,
    formatDate: contextFormatDate,
    formatDateTime: contextFormatDateTime,
    preferences,
  } = useFormatters();

  const formatCurrency = (value: string, currency?: string, decimals?: boolean | number) => {
    const num = parseFloat(value);
    return contextFormatCurrency(num, currency, decimals);
  };

  const formatDate = (dateString: string) => {
    if (!dateString) return '-';
    return contextFormatDate(dateString);
  };

  const formatDateTime = (dateString: string) => {
    if (!dateString) return '-';
    return contextFormatDateTime(dateString);
  };

  return { formatCurrency, formatDate, formatDateTime, preferences };
}
